<template>
  <input
    v-model.lazy="componentInput"
    v-money="moneyConfig"
    :class="`${'form-control text-right'} ${className}`"
    :aria-invalid="ariaInvalid"
    :required="isRequired"
  />
</template>

<script>
export default {
  props: ['value', 'isRequired', 'ariaInvalid', 'className', 'precision'],
  data() {
    return {
      componentInput: '',
      moneyConfig: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: this.precision || 2,
        masked: false
      }
    };
  },

  watch: {
    componentInput(val) {
      this.$emit('input', val);
    },

    value(val) {
      this.componentInput = val?.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
    }
  },

  created() {
    this.componentInput = this.value * 100; // Multiply by 100 only because the mask
  },

  methods: {
    brToFloat(str) {
      if (typeof str === 'string' && str !== '0,00') {
        str = str.replace(/\./g, '');
        str = parseFloat(str.replace(/,/g, '.'));
        return str;
      } else if (typeof str === 'number') {
        return str;
      } else return null;
    }
  }
};
</script>
